import React from 'react'
import Link from 'gatsby-link'
import NavContent from '../components/Nav'
import { Container, Nav, Main } from '../components/layout'
import PageTitle from '../components/PageTitle'

class Template extends React.Component {
  render() {
    const { location, children } = this.props
    let header
    if (location.pathname === '/') {
      header = (
        <Link to={'/'} >
          <PageTitle />
        </Link>
      )
    } else {
      header = (
        <Link to={'/'}>
          <PageTitle />
        </Link>
      )
    }
    return (
      <div>
        {header}
        <Container>
          <Nav>
            <NavContent />
          </Nav>
          <Main>
            {children()}
          </Main>
        </Container>
      </div>
    )
  }
}

Template.propTypes = {
  children: React.PropTypes.func,
  location: React.PropTypes.object,
  route: React.PropTypes.object,
}

export default Template



// WEBPACK FOOTER //
// ./src/layouts/index.js